import { render, staticRenderFns } from "./NonCancelableText.vue?vue&type=template&id=3a231136&functional=true"
import script from "./NonCancelableText.vue?vue&type=script&lang=js"
export * from "./NonCancelableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports